export default __webpack_public_path__ + "static/media/instagram.acfef33a.png";